import { all } from 'redux-saga/effects';
import { watchAuth } from './auth';
import { watchCourse } from './course';

export default function* rootSaga() {
  yield all([watchAuth(), watchCourse()]);
}
